import apiSlice from "./apiSlice";

const dataAlertManagementSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllDataAlerts: builder.query({
            query: (params) => ({
                url: `dataalert`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllDataAlerts"],
        }),

        getDataAlertById: builder.query({
            query: (id) => `dataalert/${id}`,
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: (result, error, id) => [{ type: "AllDataAlerts", id }],
        }),

        createDataAlert: builder.mutation({
            query: ({ body }) => ({
                url: `dataalert`,
                method: "POST",
                body,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            invalidatesTags: ["AllDataAlerts"],
        }),

        updateDataAlert: builder.mutation({
            query: ({ id, body }) => ({
                url: `dataalert/${id}`,
                method: "PUT",
                body,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            invalidatesTags: ["AllDataAlerts"],
        }),

        deleteDataAlert: builder.mutation({
            query: (id) => ({
                url: `dataalert/${id}`,
                method: "DELETE",
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            invalidatesTags: ["AllDataAlerts"],
        }),
    }),
});

export const {
    useGetAllDataAlertsQuery,
    useGetDataAlertByIdQuery,
    useCreateDataAlertMutation,
    useUpdateDataAlertMutation,
    useDeleteDataAlertMutation,
} = dataAlertManagementSlice;
